"use client";
import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { row } from './styles.js';

var Row = function Row(props) {
  return /*#__PURE__*/React.createElement(row, _extends({
    "data-testid": "elemental-Row"
  }, props));
};

export { Row };
